
<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title"> {{ 'RESERVATIONS.LISTVIEW.DETAILS.RESERVATION-DETAILS-X' | translate : {reservationdetailid: reservationDetails.Id} }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>

</div>

@if (!(isInArchiveMode || reservationDetails.ReservationTypeCode === 'BO-OPP')) {
  <div class="object-actions mt-3">
    <button (click)="startOrderProcess()" [disabled]="!orderAllowed()" class="btn btn-primary border btn-small" type="button"><i class="fas fa-cart-plus"></i>{{ 'RESERVATIONS.LISTVIEW.BUTTON.CONVERT-TO-ORDER' | translate }}</button>
    <span class="separator"></span>
    <button (click)="editSelectedReservation()" [disabled]="reservationCanBeEdited === false" class="btn btn-warning border btn-small" type="button"><i class="far fa-edit"></i>{{ 'RESERVATIONS.LISTVIEW.BUTTON.EDIT' | translate }}</button>
  </div>
}

<app-reservation-header [details]="reservationDetails"></app-reservation-header>

<t4-list-view #listVw [options]="listOptions" (onDataRequest)="OnDataRequest($event)">

  <ng-container *t4ListItem="let item">
    <td>
      @if (item.PassePartoutName != null) {
        {{ item.PassePartoutName | replaceOnEmpty:''}}
      } @else {
        @if (item.CrossSellProductName != null) {
          {{ item.CrossSellProductName | translate | replaceOnEmpty:''}}
        } @else {
          {{item.EventDate | localDateTime }} - {{item.EventName}}
        }
      }
    </td>
    @if (item.CrossSellProductVariantName == null) {
      <td>{{item.TicketTypeName | translate}}</td>
    }
    @if (item.CrossSellProductVariantName != null) {
      <td>{{item.CrossSellProductVariantName | translate | replaceOnEmpty:''}}</td>
    }
    <td>{{item.ParentSectionName}}</td>
    <td>{{item.RowNumber | replaceOnEmpty}} / {{item.SeatNumber | replaceOnEmpty}}</td>
    <td><t4-customer-identification-control [isIbaActive]="isIbaActive" [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
    <td>{{item.ContingentName | replaceOnEmpty}}</td>
    <td class="text-end">{{getLinePrice(item) | localCurrency }}</td>

  </ng-container>

</t4-list-view>


<div class="grid grid-row">
  <div class="grid-cell" fxFlex></div>
  <div class="grid-cell text-end" fxFlex="80px"><b>{{ calculateTotal() | localCurrency }}</b></div>
</div>
